import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { hasConsent } from "../../utils/CookieConsent";
import {
  disableGoogleAnalytics,
  loadGoogleAnalytics,
  trackGaPageView,
} from "../../utils/googleAnalytics";
import {
  disableMarketingPixels,
  loadMarketingPixels,
  trackMarketingPageView,
} from "../../utils/marketingPixels";

export const getAnalyticsPagePath = (location) => {
  const realPath =
    typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}`
      : "";
  if (/^\/(en|vi)(\/|$)/.test(realPath)) {
    return realPath;
  }
  return `${location.pathname}${location.search}`;
};

const syncGoogleAnalytics = (path) => {
  if (hasConsent("analytics")) {
    loadGoogleAnalytics();
    trackGaPageView(path);
    return;
  }
  disableGoogleAnalytics();
};

const syncMarketingPixels = ({ isRouteChange }) => {
  if (hasConsent("marketing")) {
    const alreadyLoaded = !!window.__marketingLoaded;
    loadMarketingPixels();
    if (alreadyLoaded && isRouteChange) {
      trackMarketingPageView();
    }
    return;
  }
  disableMarketingPixels();
};

const TrackingLoader = () => {
  const location = useLocation();
  const lastGaPathRef = useRef(null);
  const lastMktPathRef = useRef(null);

  useEffect(() => {
    const path = getAnalyticsPagePath(location);

    if (
      !(
        lastGaPathRef.current === path &&
        hasConsent("analytics") &&
        window.__gaLoaded
      )
    ) {
      lastGaPathRef.current = path;
      syncGoogleAnalytics(path);
    }

    if (
      !(
        lastMktPathRef.current === path &&
        hasConsent("marketing") &&
        window.__marketingLoaded
      )
    ) {
      const isRouteChange =
        lastMktPathRef.current !== null && lastMktPathRef.current !== path;
      lastMktPathRef.current = path;
      syncMarketingPixels({ isRouteChange });
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handler = (e) => {
      const path = getAnalyticsPagePath(location);
      if (e.detail?.analytics) {
        lastGaPathRef.current = path;
        loadGoogleAnalytics();
        trackGaPageView(path);
      } else {
        disableGoogleAnalytics();
      }

      if (e.detail?.marketing) {
        lastMktPathRef.current = path;
        loadMarketingPixels();
      } else {
        disableMarketingPixels();
      }
    };
    window.addEventListener("cookie-consent-changed", handler);
    return () => window.removeEventListener("cookie-consent-changed", handler);
  }, [location.pathname, location.search]);

  return null;
};

export default TrackingLoader;
